export const PLATFORM_OPTIONS = [
  {label:"Tripadvisor", id:"TRIPADVISOR_META" },
  {label:"Google Hotel Ads", id:"GHA_META" },
  {label:"Google Hotel Ads - FBL", id:"GHA_FBL" },
  {label:"Trivago", id:"TRIVAGO_META" },
  {label:"Skyscanner", id:"SKYSCANNER" },
  {label:"Wego", id:"WEGO" },
  {label:"Kayak", id:"KAYAK" },
  {label:"Bing", id:"BING" },
];

export const DESIGNATION_PLATFORM_OPTIONS = [
  {label:"Google Hotel Ads - Property Promotion Ads", id:"GHA_PPA" },
  {label:"Bing Hotel Ads - Property Promotion Ads", id:"BING_PPA" },
  {label:"Tripadvisor - Sponsored Placement", id:"TRIPADVISOR_SP" },
  {label:"Trivago - Sponsored Listing", id:"TRIVAGO_SL" },
];

export const OTHER_ADS_OPTIONS = [
  {label:"SEM", id:"GHA_SEM" },
  {label:"Display Ads", id:"DISPLAY_ADS" },
  {label:"AI Connect", id:"AI_CONNECT" }
]

export const BILLING_MODE_OPTIONS = [
  {id:"ABO", label:"ABO : Direct Booking" },
  {id:"BA", label:"BA : Tripadvisor Business Advantage" },
  {id:"CPC", label:"CPC : Cost Per Click" },
  {id:"CPA", label:"COM : Commission (Net of Cancellation), CONV : Pay Per Conversion" },
  {id:"FRE", label:"FREE : Free Campaign" },
  {id:"PPS", label:"PPS : Pay Per Stay" }
];

export const BOOKING_STATUS_OPTIONS = [
  {label:"Stayed", value:"S" },
  {label:"Canceled", value:"C" },
  {label:"No Show", value:"N" }
];